export default "<div\n  class=\"chip\"\n  [ngClass]=\"chipClass\"\n>\n  <ng-content></ng-content>\n</div>\n";